export enum DiscountTypes {
  AMOUNT = 0,
  PERCENTAGE = 1,
}
